import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useThemeMode } from '../components/ThemeModeContext';
import AppStarLogo from '../images/appstar_title_tr.png';
import Copyright from '../components/Copyright';

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  const { isDarkMode, clearOverride } = useThemeMode();

  useEffect(() => {
    clearOverride();
    window.scrollTo(0, 0);
  }, [clearOverride]);

  return (
    <div style={{
      minHeight: '100vh',
      background: isDarkMode ? '#121212' : '#f1f5f9',
      color: isDarkMode ? '#f1f5f9' : '#0f172a',
      padding: '2rem 1rem'
    }}>
      <div style={{ maxWidth: 800, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img src={AppStarLogo} alt="AppStar Logo" style={{ width: 100, marginBottom: 12 }} />
          <h1 style={{ fontSize: '2rem', fontWeight: 700, margin: 0 }}>AppStar Privacy Policy</h1>
          <p style={{ opacity: 0.7, marginTop: '0.5rem' }}>Last updated: November 2025</p>
        </div>

        <div style={{ lineHeight: 1.7 }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            1. Introduction
          </h2>
          <p>
            AppStar is a vibe coding app designed to help users build creative applications using AI-powered tools. 
            This Privacy Policy explains how we handle your information, what you should avoid including in your projects, 
            and the responsibilities you accept when using AppStar.
          </p>
          <p>By using AppStar, you agree to the terms outlined in this Privacy Policy.</p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            2. Information You Provide
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li>AppStar uses the OpenAI API to generate code and content.</li>
            <li>Do not include personal information such as passwords, phone numbers, addresses, financial details, 
            or any other sensitive data in your projects.</li>
            <li>Any information you enter into AppStar may be processed by third-party AI providers. We cannot guarantee 
            whether those providers use the data for training their models.</li>
            <li><strong>Important:</strong> Do not use AppStar to input private or proprietary data that you would not 
            want shared or potentially used to train external AI models.</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            3. Visibility of Your Apps
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li>Apps you build in AppStar are visible to you as the creator.</li>
            <li>If you choose to make your app Public, it may be visible to other AppStar users.</li>
            <li>Public apps may also be published on a webserver, making them accessible to the general public worldwide.</li>
            <li><strong>Warning:</strong> Do not include any private information in your apps that you would not want 
            the world to see.</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            4. Data Collection
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li>AppStar collects limited data for security and quality assurance purposes.</li>
            <li>This data is not used by AppStar for training AI models.</li>
            <li>However, because AppStar relies on third-party AI providers, we cannot guarantee that those providers 
            will not use submitted data for training.</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            5. Prohibited Use
          </h2>
          <p>You may not use AppStar to:</p>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li>Recreate proprietary, copyrighted, trademarked, or patented software.</li>
            <li>Use names, logos, or marks that infringe on intellectual property rights.</li>
          </ul>
          <p>Violation of these terms may expose you to legal action from the rightful owners of such software or names.</p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            6. Legal Responsibility & Indemnification
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li>You are solely responsible for the content you create and share using AppStar.</li>
            <li>By using AppStar, you agree to indemnify and hold harmless AppStar from any claims, damages, 
            or legal actions arising from your misuse of the app, including intellectual property violations.</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            7. Changes to This Policy
          </h2>
          <p>
            We may update this Privacy Policy from time to time. Updates will be posted within the app, and continued 
            use of AppStar after changes indicates your acceptance of the revised policy.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            8. Contact
          </h2>
          <p>
            If you have questions about this Privacy Policy, please contact us at:{' '}
            <a href="mailto:appstar@zylascope.com" style={{ color: '#6366f1', textDecoration: 'underline' }}>
              appstar@zylascope.com
            </a>
          </p>
        </div>

        <div style={{ textAlign: 'center', marginTop: '3rem', marginBottom: '2rem' }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              padding: '0.75rem 2rem',
              background: 'var(--dark-blue)',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              fontSize: '1rem',
              fontWeight: 700,
              cursor: 'pointer',
              boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
            }}
          >
            Sign Up
          </button>
        </div>
        
        <Copyright sx={{ mt: 5, mb: 2 }} />
      </div>
    </div>
  );
}
